import { httpClient } from '@/api/httpClient';
import type { LocalMoment } from '@/utils/localMoment';
import {
  mapApiResourceToAssistantBriefStart,
  mapApiResourceToAssistantPulse,
  mapApiResourceToAssistantUserPreferences,
} from './assistantProactiveMapping';
import type {
  AssistantBriefKind,
  AssistantBriefStart,
  AssistantBriefStartApiResource,
  AssistantHintKey,
  AssistantPulse,
  AssistantPulseApiResource,
  AssistantUserPreferences,
  AssistantUserPreferencesApiResource,
  AssistantUserPreferencesUpdate,
} from './assistantProactiveApi.types';

const ASSISTANT_BASE_PATH = '/assistant';

export async function fetchAssistantPulse(moment: LocalMoment): Promise<AssistantPulse> {
  const response = await httpClient.get<AssistantPulseApiResource>(ASSISTANT_BASE_PATH + '/pulse', {
    params: { local_date: moment.localDate, local_hour: moment.localHour },
  });
  return mapApiResourceToAssistantPulse(response.data);
}

export async function fetchAssistantUserPreferences(): Promise<AssistantUserPreferences> {
  const response = await httpClient.get<AssistantUserPreferencesApiResource>(
    ASSISTANT_BASE_PATH + '/preferences'
  );
  return mapApiResourceToAssistantUserPreferences(response.data);
}

export async function updateAssistantUserPreferences(
  update: AssistantUserPreferencesUpdate
): Promise<AssistantUserPreferences> {
  const response = await httpClient.put<AssistantUserPreferencesApiResource>(
    ASSISTANT_BASE_PATH + '/preferences',
    { proactive_enabled: update.proactiveEnabled, auto_brief_enabled: update.autoBriefEnabled }
  );
  return mapApiResourceToAssistantUserPreferences(response.data);
}

export async function dismissAssistantHint(hintKey: AssistantHintKey): Promise<void> {
  await httpClient.post(ASSISTANT_BASE_PATH + '/hints/' + hintKey + '/dismiss');
}

export async function startAssistantBrief(
  kind: AssistantBriefKind,
  moment: LocalMoment
): Promise<AssistantBriefStart> {
  const response = await httpClient.post<AssistantBriefStartApiResource>(
    ASSISTANT_BASE_PATH + '/briefs/' + kind,
    { local_date: moment.localDate, local_hour: moment.localHour }
  );
  return mapApiResourceToAssistantBriefStart(response.data);
}
